<template>
  <div class="d-flex flex-wrap">
    <h2 class="col-3 mb-4">{{ $t('autocaller_v2.monitoring.tasks.topic') }}</h2>
    <colors-map :colors="tasks_colors" />
    <div class="col-12">
      <numbers-tasks :tasks="tasks" />
    </div>
  </div>
</template>

<script>
  import ColorsMap from './monitoring-colors-map';
  import NumbersTasks from './monitoring-numbers-tasks'
  export default {
    components: {
      ColorsMap,
      NumbersTasks
    },
    props: {
      tasks: {
        type: [Array, String],
        default: () => []
      }
    },
    computed: {
      tasks_colors() {
        return [
          {
            name: this.$t('autocaller_v2.monitoring.tasks.pending.state'),
            state: 'pending'
          },
          {
            name: this.$t('autocaller_v2.monitoring.tasks.connected.state'),
            state: 'connected'
          },
          {
            name: this.$t('autocaller_v2.monitoring.tasks.dialing.state'),
            state: 'dialing'
          },
          {
            name: this.$t('autocaller_v2.monitoring.tasks.active.state'),
            state: 'active'
          },
          {
            name: this.$t('autocaller_v2.monitoring.tasks.processing.state'),
            state: 'processing'
          }
        ]
      }
    }
  }
</script>